import { InputStylesProp, StyledLabelStylesProp, StylesProp } from './types';
import styled, { css } from 'styled-components';

import { InputContainerStyleProps } from 'features/common/components/Form/types';

const checkedSwitch = ({ disabled }: any) => css`
	+ span {
		opacity: ${disabled && 0.75};
		> span {
			transform: translateX(0px);
		}
	}
`;

const notCheckedSwitch = () => css`
	+ span {
		> span {
			transform: translateX(0);
		}
	}
`;

export const StyledLabel = styled.label<StyledLabelStylesProp>`
	position: relative;
	width: 168px;
	height: 34px;
	box-sizing: border-box;
	cursor: ${({ disabled }) => !disabled && 'pointer'};
`;

export const PunchupInputContainer = styled.div<InputContainerStyleProps>`
	margin-bottom: 24px;
`;

export const Input = styled.input<InputStylesProp>`
	transform: scale(0);
	+ span {
		width: 168px;
		height: 48px;
		bottom: 10px;
		display: flex;
		align-items: center;
		> span {
			opacity: ${({ disabled }) => disabled && 0.75};
		}
	}
	${({ theme, isPercentage, disabled }) => (isPercentage ? checkedSwitch({ theme, disabled }) : notCheckedSwitch())};
`;

export const BackgroundContainer = styled.div<StylesProp>`
	position: relative;
	width: 168px;
`;

export const Background = styled.span<StylesProp>`
	border-radius: 10px;
	height: 48px;
	left: 0;
	transition: background 0.4s;
	position: absolute;
	width: 100%;
	opacity: ${({ disabled, isPercentage }) => disabled && (isPercentage ? '0.75' : '0.75')};
	display: flex;
	justify-content: space-between;
	flex-direction: ${({ isPercentage }) => (isPercentage ? 'row-reverse' : 'row')};
	transition: transform 0.45s;
	border: 1px solid #e0e0e0;
	box-sizing: border-box;
`;

export const Circle = styled.span<StylesProp>`
	width: 82px;
	color: white;
	background: ${({ theme }) => theme.colors.punchupOrange};
	border-radius: 7.5px;
	transition: transform 0.45s;
	display: flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	margin: 1px;
	z-index: 2;

	&:disabled {
		opacity: 0.75;
	}
`;

export const UncheckedIconContainer = styled.div<StylesProp>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 84px;
	border-radius: 8px;
	z-index: 1;
	cursor: pointer;
`;
